import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../rest_services/user.service';
import { users } from './user';
import { NavigationService } from '../rest_services/navigation.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {

  logged:any;error_log:boolean=false;connexionLoad:boolean=false;
  loginForm: FormGroup;logRequest:any;loginRequest:any;

  constructor(
    private fb: FormBuilder, 
    private router:Router,
    private userServiceService:UserService,
    private navigationService:NavigationService) {

    this.loadScript("assets/js/mdl/material.min.js");
    this.loginForm = this.fb.group({
      'login': ['', Validators.required],
      'password' : ['', Validators.required],
      'session':['']
    });
  }

  ngAfterViewInit() {
    // Sélectionner tous les champs input
    const inputs = document.querySelectorAll('.mdl-textfield__input');
    
    // Pour chaque input, ajouter les écouteurs d'événements
    inputs.forEach(input => {
      const field = input.closest('.mdl-textfield') as any;
      
      // Vérifier si le champ a déjà une valeur lors du chargement
      if (input instanceof HTMLInputElement && input.value) {
        field.classList.add('is-dirty');
      }
      
      // Ajouter un écouteur pour le focus
      input.addEventListener('focus', () => {
        field.classList.add('is-focused');
      });
      
      // Ajouter un écouteur pour la perte de focus
      input.addEventListener('blur', () => {
        field.classList.remove('is-focused');
        
        // Si l'input a une valeur, ajouter is-dirty
        if (input instanceof HTMLInputElement && input.value) {
          field.classList.add('is-dirty');
        } else {
          field.classList.remove('is-dirty');
        }
      });
      
      // Ajouter un écouteur pour l'input (saisie)
      input.addEventListener('input', () => {
        if (input instanceof HTMLInputElement && input.value) {
          field.classList.add('is-dirty');
        } else {
          field.classList.remove('is-dirty');
        }
      });
    });
  }
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  ngOnInit(): void {
    this.loadScript("assets/js/mdl/material.min.js");
    setTimeout(()=>{
      $('#eq-loader').hide();
      $('#show_hide_password input').attr('type', 'password');
      $("#show_pass").hide();
      $("#hide_pass").show();
    },1000);
    if(localStorage.getItem("logged")!=null){
      this.logged=localStorage.getItem("logged");
    }else {
      this.logged=sessionStorage.getItem("logged");
    }
    
    if(this.logged ==undefined || this.logged==null){      
      if (window.location.href.includes("signin")) {
        $("body").addClass("public_back");
        this.router.navigate(['../signin']);
      } else {
        this.router.navigate(['../signin']);
      }
    }else {
      if(localStorage.getItem("role")=="adm" || sessionStorage.getItem("role")=="adm"){
        this.router.navigate(['../dashboard']);
      }  else if (localStorage.getItem("role")=="asst" || sessionStorage.getItem("role")=="asst"){
        this.router.navigate(['../dash']);
      }  else if (localStorage.getItem("role")=="asst" || sessionStorage.getItem("role")=="asst"){
        this.router.navigate(['../dash']);
      } else {
        this.router.navigate(['../mydash']);
      }
      $("body").removeClass("public_back"); 
      return;
      
    }
  }
  myPack:any=null;
  login(event:any){
    $("#show_pass").hide();
    $("#hide_pass").hide();
    var formvalues = this.loginForm.value;
    this.connexionLoad= true;
    var user = users.find(obj => obj.log == formvalues.login && obj.password == formvalues.password);
    if(this.loginForm.valid){
      this.logRequest = {
        login :formvalues.login,
        password:formvalues.password
      };
      this.userServiceService.loginRequest = this.logRequest;
      this.userServiceService.log_user();
      this.loginRequest=this.userServiceService.loginSubject.subscribe(
        ( data: any ) => {
          if(data.code =="a976019dbbfbcae6b0b13b4acac5f0bd"){
            let decodedJWT = JSON.parse(window.atob(data.token.split('.')[1]));            
            var role;
            var dash;
            switch (decodedJWT.role) {
              case "a21aab19-d73e-47db-a61c-d2c1f0c8a251":
                role = "cmrc";
                dash = "/mydash";
                break;
              case "d8aeff31-284b-11ed-8482-00163ee67c31":
                role = "asst";
                dash = "/dash";
                break;
              case "981dc265-63b8-45ba-b356-befb5a9a6f74":
                role = "adm";
                dash = "/dashboard";
                break;
              case "96e04ad6-1ff3-11ee-be56-0242ac120002":
                role = "adm-MF";
                dash = "/administration";
                break;
              case "3a72a811-86cf-4ea8-b561-9f3cef0fb6e5":
                role = "support";
                dash = "/dash-support";
                break;
              default:
                role = data.profile;
                dash = '/dashboard';
                break;
            }
            if (role&&dash) {
              const userRole = localStorage.getItem('role');

              // Naviguer vers le dashboard et effacer l'historique
              this.navigationService.navigateToDashboardAndClearHistory(role);
              if(formvalues.session==true){
                localStorage.setItem("msToken",data.msToken);
                localStorage.setItem("logged","signin");
                localStorage.setItem("role",role);
                localStorage.setItem("token",data.token);
                localStorage.setItem("comp",decodedJWT.company);
                localStorage.setItem("prf",decodedJWT.role);
                if(data.account != null && data.account != undefined){
                  localStorage.setItem("pk", data.account.pk+"-"+data.account.pk_rest.toString());
                  localStorage.setItem("trats_kp",new Date(data.account.pk_start).getTime().toString());
                  localStorage.setItem("dne_kp",new Date(data.account.pk_end).getTime().toString());
                }
              }else {
                sessionStorage.setItem("msToken",data.msToken);
                sessionStorage.setItem("logged","signin");
                sessionStorage.setItem("role",role);
                sessionStorage.setItem("token",data.token);
                sessionStorage.setItem("comp",decodedJWT.company);
                sessionStorage.setItem("prf",decodedJWT.role);
                if(data.account != null && data.account != undefined){
                  sessionStorage.setItem("pk", data.account.pk+"-"+data.account.pk_rest.toString());
                  sessionStorage.setItem("trats_kp",new Date(data.account.pk_start).getTime().toString())
                  sessionStorage.setItem("dne_kp",new Date(data.account.pk_end).getTime().toString())
                }
              }
              window.location.href = dash;
            } else {
              this.connexionLoad= false;
              this.error_log = true;
              
              $('#error').fadeIn(1000);
              setTimeout(()=>{
                $("#show_pass").hide();
                $("#hide_pass").show();
              },200);
              setTimeout(()=>{
                $('#error').fadeOut(1000);
              },5000);
            }
            setTimeout(()=>{
              this.connexionLoad= false;
            },2000);
          } else {
            this.connexionLoad= false;
            this.error_log = true;
            $('#error').fadeIn(1000);
            setTimeout(()=>{
              $("#show_pass").hide();
              $("#hide_pass").show();
            },200);
            setTimeout(()=>{
              $('#error').fadeOut(1000);
              window.location.reload();
            },5000);
          }
          this.loginForm.reset();
        }, 
        error => {
          this.connexionLoad= false;
          this.error_log = true;
            $('#error').fadeIn(1000);
            setTimeout(()=>{
              $('#error').fadeOut(1000);
            },5000);
          setTimeout(()=>{
            this.connexionLoad= false;
          },2000);
          $("#show_pass").hide();
          $("#hide_pass").show();
        }
      );
    }else {
      this.connexionLoad= false;
      this.error_log = true;
            $('#error').fadeIn(1000);
            setTimeout(()=>{
              $('#error').fadeOut(1000);
            },5000);
          setTimeout(()=>{
            this.connexionLoad= false;
          },2000);
    }
    
    $('#eq-loader').hide();
  }
  showHidePass(action:any){    
    if(action === "show"){
        $('#show_hide_password input').attr('type', 'text');
        $("#show_pass").show();
        $("#hide_pass").hide();
    }else{
      $('#show_hide_password input').attr('type', 'password');
      $("#hide_pass").show();
      $("#show_pass").hide();
    }
  }
}
